module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEoSURBVEhL7ZW9TgJBFEa3QFAJHTyElVhY0EFHYkJlR6h8KysbY4OxMECIiYFXoLWlAkkIBQ2465nZb0kIUOzOVMaTfLm7c++e2WJ/gn+iKMqHYfhIVmRAKmq5I/kbdQfnEy+b4DqQJ7De01g2cBj5a6w7ylKj6eHiM+Td2HOSJ42nB/mLJEehP6ScazwdXFi1lhMg/6Bcajw9CG5j1SH0PilO8hbZxLp9WB9TsssNCOqItta4z4j1osaygeBCtZ1sQr0jDQ5zdigrSK7JlLR03iQPtumK5DPdcVfLfsBZRTqX/J2SV8sdhDfkW/KeNzmyGrknC8n7PuVX5MeIDRybb3tBbXeQPcudUFbLHeQlspbY3P0Xsc++NxCaT4H5G3XYw+3l+UMEwS84VvsEMA4IgwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-screwdriver/light/24.png
// module id = 2408
// module chunks = 2